import React, { useState, useEffect, useCallback } from 'react';
import { getAuth, verifyPasswordResetCode, confirmPasswordReset, signInWithEmailAndPassword } from "firebase/auth";
import { useSearchParams, useNavigate } from 'react-router-dom';
import Footer from './components/Footer';
import Header from './components/Header';

function CustomResetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [email, setEmail] = useState('');
  const [isCodeValid, setIsCodeValid] = useState(false);
  const [oobCode, setOobCode] = useState('');
  const [isResetComplete, setIsResetComplete] = useState(false);

  // Memoize the getFriendlyMessage function to avoid lint issues
  const getFriendlyMessage = useCallback((errorCode) => {
    const firebaseErrorMessages = {
      "auth/weak-password": "Your password is too weak. Please choose a password with at least 6 characters.",
      "auth/expired-action-code": "The reset link has expired. Please request a new reset link.",
      "auth/invalid-action-code": "The reset link is invalid or has already been used.",
      "auth/user-not-found": "No user found with the provided email address.",
    };
    return firebaseErrorMessages[errorCode] || "An unexpected error occurred. Please try again.";
  }, []);

  useEffect(() => {
    const code = searchParams.get('oobCode');
    const mode = searchParams.get('mode');
    setOobCode(code);

    if (mode !== 'resetPassword' || !code) {
      setMessage('Invalid or missing reset code.');
      return;
    }

    const auth = getAuth();
    verifyPasswordResetCode(auth, code)
      .then((email) => {
        setEmail(email);
        setIsCodeValid(true);
      })
      .catch((error) => {
        const friendlyMessage = getFriendlyMessage(error.code);
        setMessage(`Error: ${friendlyMessage}`);
      });
  }, [searchParams, getFriendlyMessage]);

  const handlePasswordReset = async () => {
    if (newPassword !== confirmPassword) {
      setMessage('Passwords do not match.');
      return;
    }

    const auth = getAuth();
    try {
      await confirmPasswordReset(auth, oobCode, newPassword);
      setMessage('Password has been successfully reset.');
      await signInWithEmailAndPassword(auth, email, newPassword);
      setIsResetComplete(true);
    } catch (error) {
      const friendlyMessage = getFriendlyMessage(error.code);
      setMessage(`Error: ${friendlyMessage}`);
    }
  };

  return (
    <div className="properties-page">
      <Header />
      <div className="my-account-content">
        {!isCodeValid ? (
          <section>
            
            <p>{message}</p>
          </section>
        ) : isResetComplete ? (
          <section>
            <h2>Success!</h2>
            <p>Your password has been reset, and you are now logged in.</p>
            <button
              className="property-action-button"
              onClick={() => navigate('/properties')}
            >
              Go to My Properties
            </button>
          </section>
        ) : (
          <section>
            <h2>Reset Your Password</h2>
            <p>Resetting password for: <strong>{email}</strong></p>
            <input
              type="password"
              placeholder="New Password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              style={{ padding: '10px', width: '100%', marginBottom: '10px', marginTop: '10px', maxWidth: '320px' }}
            /><br/>
            <input
              type="password"
              placeholder="Confirm New Password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              style={{ padding: '10px', width: '100%', marginBottom: '10px', maxWidth: '320px' }}
            /><br/>
            <button
              className="property-action-button"
              onClick={handlePasswordReset}
              style={{ marginRight: '10px' }}
            >
              Reset Password
            </button>
            {message && <p style={{ color: 'red' }}>{message}</p>}
          </section>
        )}
      </div>
      <Footer />
    </div>
  );
}

export default CustomResetPassword;
